"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TheArchaicFoundationInstitute = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const Size_1 = require("../render/Size");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const constants_1 = require("../../constants");
class TheArchaicFoundationInstitute extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.THE_ARCHAIC_FOUNDATION_INSTITUTE,
            tags: [Tags_1.Tags.MOON, Tags_1.Tags.MOON],
            startingMegaCredits: 55,
            resourceType: ResourceType_1.ResourceType.RESOURCE_CUBE,
            metadata: {
                description: 'You start with 55 M€.',
                cardNumber: 'MC10',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br;
                    b.megacredits(55);
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect(undefined, (eb) => {
                            eb.moon().startEffect.resourceCube();
                        });
                        ce.vSpace();
                        ce.effect('When you play a Moon tag, add a resource cube to this card. Automatically remove every 3 resource cubes collected here to increase your TR 1 step.', (eb) => {
                            eb.resourceCube(3).startEffect.tr(1, Size_1.Size.SMALL);
                        });
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    play() {
        return undefined;
    }
    onCardPlayed(player, card) {
        if (!player.isCorporation(this.name))
            return;
        const moonTags = card.tags.filter((t) => t === Tags_1.Tags.MOON);
        const count = moonTags.length;
        if (count > 0) {
            player.addResourceTo(this, count);
            if (this.resourceCount >= 3) {
                const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
                const canAffordToRaiseTR = redsAreRuling ? player.canAfford(constants_1.REDS_RULING_POLICY_COST) : true;
                if (canAffordToRaiseTR) {
                    player.removeResourceFrom(this, 3, player.game, player, true);
                    player.increaseTerraformRatingSteps(1);
                }
            }
        }
        ;
        return undefined;
    }
}
exports.TheArchaicFoundationInstitute = TheArchaicFoundationInstitute;
//# sourceMappingURL=TheArchaicFoundationInstitute.js.map